import { ArrayUtils } from '../../../../shared/utils/ArrayUtils.ts';
import { UITopNotificationType } from '../../../shared/scripts/notifications/UINotificationController.ts';
import { SocketLobbySend } from '../../../shared/scripts/socket/SocketLobbySend.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UITopNotificationView } from './UITopNotificationView.ts';
import { getHomepageUrlWithParameter, navigateToPage, throttleUserAction } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { UIUrlParameterNames } from '../../../shared/scripts/ui_html/UIUrlController.ts';
export class UITopNotificationController {
    static show(text, type, buttonText, action, removeAction, showCloseButton = true, duration) {
        this.views.push(new UITopNotificationView(text, type, buttonText, action, removeAction, showCloseButton, duration));
    }
    static showGames(games) {
        for (const game of games){
            if (this.gameIds.includes(game.id)) continue;
            if (this.rejectedGameIds.includes(game.id)) continue;
            this.gameIds.push(game.id);
            const disconnectTranslation = game.disconnected ? {
                key: 'strings:homePage.notifications.disconnectedFromGame',
                options: {
                    context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : undefined,
                    playerCount: game.playerCount,
                    gameId: UIUtilsEjsVariables.isUserOnDiscord ? undefined : game.id
                }
            } : {
                key: 'strings:homePage.notifications.activeGame',
                options: {
                    context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : undefined,
                    playerCount: game.playerCount,
                    gameId: UIUtilsEjsVariables.isUserOnDiscord ? undefined : game.id
                }
            };
            const reconnectAction = uiGameManager != undefined ? throttleUserAction(()=>SocketLobbySend.reconnectGame(game.id)) : ()=>navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.ReconnectGame, game.id));
            this.show(disconnectTranslation, UITopNotificationType.Reconnect, {
                key: 'strings:homePage.notifications.reconnect'
            }, reconnectAction, ()=>{
                ArrayUtils.removeElementFromArray(this.gameIds, game.id);
                this.rejectedGameIds.push(game.id);
            });
        }
    }
    static removeDisconnectBanners() {
        this.removeBanners(UITopNotificationType.Reconnect);
    }
    static removeSocketErrorBanners() {
        this.removeBanners(UITopNotificationType.SocketError);
    }
    static removeBanners(type) {
        for (const view of this.views){
            if (view.type != type) continue;
            view.hide();
            ArrayUtils.removeElementFromArray(this.views, view);
        }
    }
}
UITopNotificationController.gameIds = [];
UITopNotificationController.rejectedGameIds = [];
UITopNotificationController.views = [];
